import { z } from 'zod';

/** Login Step 2 — verify 6-digit OTP. */
export const otpSchema = z.object({
  otp: z
    .string()
    .min(6, 'Enter the 6-digit verification code')
    .max(6, 'Code must be exactly 6 digits')
    .regex(/^\d{6}$/, 'Code must contain only digits'),
});

export type OtpFormValues = z.infer<typeof otpSchema>;

export const defaultOtpValues: OtpFormValues = {
  otp: '',
};
